var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "portfolio__more main-btn",
      attrs: { type: "button", disabled: this.$props.disabled ? true : false },
      on: { click: _vm.showMore },
    },
    [
      _c("span", [_vm._v("Больше работ")]),
      _vm._v(" "),
      _c("svg", { attrs: { width: "24", height: "24" } }, [
        _c("use", {
          attrs: { "xlink:href": "./assets/sprite.svg#icon-btn-arrow" },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }